const Stepper = () => {
    return(
        <>
        <div className="outer-wrapper relative my-[3rem]  flex justify-center w-[100%]" >
    <div className="inner-wrapper ">
      <div className="main-stepper flex">
        <div id="step-1" className="stepper-inprogress step-1 w-[28%]" data-target="step1-1">
          <div className="flex">
            <img src="/nrp-icons/booking-icon/shipper-information.svg" alt="" className="shipper-icon rounded-full h-[2.5rem] w-[2.5rem] p-[.5rem]"/>
            <hr className="horizontal-line h-[0.2rem] w-[10rem] my-[1rem] mx-[1.5rem]"/>
          </div>
          <p className="text-xs text-[#A3A3A3] leading-5 font-bold">STEP 1</p>
          <p className="font-bold leading-2">Shipper Information</p>
          <p className="shipper-chip rounded-xl text-white text-center w-[6.2rem]">In Progress</p>
          
        </div>
        <div className="stepper-Pending step-2 w-[28%]" id="step-2">
          <div className="flex ">
            <img src="/nrp-icons/booking-icon/delivery-information.svg" alt="" className="Delivery-icon rounded-full  h-[2.5rem] w-[2.5rem] p-[.5rem]"/>
            <hr className="horizontal-line h-[0.2rem] w-[10rem] my-[1rem] mx-[1.5rem]"/>
          </div>
          <p className="text-xs text-[#A3A3A3] leading-5 font-bold">STEP 2</p>
          <p  className="font-bold">Delivery Information</p>
          <p className="Delivery-chip rounded-xl text-white text-center w-[6rem]">Pending</p>
        </div>

        <div className="stepper-completed step-3 w-[28%]">
          <div className="flex">
            <img src="/nrp-icons/booking-icon/add-attestation-services.svg" alt="" className="attestation-icon rounded-full h-[2.5rem] w-[2.5rem] p-[.5rem]"/>
            <hr className="horizontal-line h-[0.2rem] w-[10rem] bg-[#efefef] my-[1rem] mx-[1.5rem]"/>
          </div>
          <p className="text-xs text-[#A3A3A3] leading-5 font-bold">STEP 3</p>
          <p  className="font-bold">Add attestaion Services</p>
          <p className="attestation-chip rounded-xl text-white text-center w-[6rem]">Pending</p>
        </div>
        <div className="stepper-pending step-4 w-[16%]">
          <div className="flex">
            <img src="/nrp-icons/booking-icon/payment.svg" alt="" className="payment-icon rounded-full bg-[#efefef] h-[2.5rem] w-[2.5rem] p-[.5rem]"/>
          </div>
          <p className="text-xs text-[#A3A3A3] leading-5 font-bold">STEP 4</p>
          <p  className="font-bold">Payment  </p>
          <p className="payment-chip rounded-xl bg-[#efefef] text-white text-center w-[6rem]">Pending</p>
        </div>
      </div>
    </div>
  </div>
        </>
    );
};
export default Stepper;